import {Injectable} from '@angular/core';
import {ToastrService} from 'ngx-toastr';

@Injectable({
    providedIn: 'root'
})
export class ToastService {

    /**
     * Default toast timeout in milliseconds
     */
    private readonly DEFAULT_TOAST_TIMEOUT = 3000;

    /**
     * Constructor
     *
     * @param toastr - Toastr service
     */
    constructor(private toastr: ToastrService) {
    }

    /**
     * Show toast success
     * @param message - Toast message
     * @param title - Toast title
     * @param timeOut - Toast timeout
     */
    public success(message: string, title = 'Sucesso', timeOut: number = this.DEFAULT_TOAST_TIMEOUT) {
        this.toastr.success(message, title, {
            timeOut,
            progressBar: true
        });
    }

    /**
     * Show toast error
     * @param message - Toast message
     * @param title - Toast title
     * @param timeOut - Toast timeout
     */
    public error(message: string, title = 'Erro', timeOut: number = this.DEFAULT_TOAST_TIMEOUT) {
        this.toastr.error(message, title, {
            timeOut,
            progressBar: true
        });
    }

    /**
     * Show toast warning
     * @param message - Toast message
     * @param title - Toast title
     * @param timeOut - Toast timeout
     */
    public warning(message: string, title = 'Atenção', timeOut: number = this.DEFAULT_TOAST_TIMEOUT) {
        this.toastr.warning(message, title, {
            timeOut,
            progressBar: true
        });
    }

    /**
     * Show toast info
     * @param message - Toast message
     * @param title - Toast title
     * @param timeOut - Toast timeout
     */
    public info(message: string, title = 'Aviso', timeOut: number = this.DEFAULT_TOAST_TIMEOUT) {
        this.toastr.info(message, title, {
            timeOut,
            progressBar: true
        });
    }


}
